import { render, staticRenderFns } from "./matters.vue?vue&type=template&id=fa1f52ba&"
import script from "./matters.vue?vue&type=script&lang=js&"
export * from "./matters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports